import { Injectable, inject } from '@angular/core';
import { AuthService } from '../auth/auth.service';

@Injectable({ providedIn: 'root' })
export class PermissionService {
    private authService = inject(AuthService);

    /**
     * Check if current user has a specific permission.
     * Usage: permService.can('backoffice', 'module', 'edit')
     */
    can(project: string, module: string, action: string): boolean {
        const perms = this.authService.getUser()?.permissions;
        if (!perms) return false;
        const key = `${project}:${module}`;
        return perms[key]?.includes(action) ?? false;
    }

    /**
     * Check if current user has ANY permission in a project.
     */
    hasAnyPermission(project: string): boolean {
        const perms = this.authService.getUser()?.permissions;
        if (!perms) return false;
        return Object.keys(perms).some(k => k.startsWith(`${project}:`));
    }

    /**
     * Get all actions the user can do on a specific module.
     */
    getActions(project: string, module: string): string[] {
        const perms = this.authService.getUser()?.permissions;
        if (!perms) return [];
        return perms[`${project}:${module}`] ?? [];
    }
}
